module.exports = __webpack_public_path__ + "img/dianpu.a55d9840.svg";